import { mixed, object, string } from "yup";

export const addExistingRegistrationValidation = object().shape({
  state_id: string().when("state_registration_id", {
    is: (val: string) => !!val,
    then: string().required("State ID is required "),
    otherwise: string().notRequired(),
  }),
  payment_schedule: string().required("Please select payment schedule"),
  registration_license: mixed().required("Please upload registration license"),
  tax_detail_id: string().when("existingTaxAccount", {
    is: "YES",
    then: (schema) => schema.required("Existing tax accounts ID is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  sales_tax_id: mixed().required("Sales tax ID is required"),
  filing_start_date: string().required("Filing start date is required"),
  application: mixed().optional(),
});
